import { createContext } from 'react';
import { initialState } from './ACL.constants';
import { ACLContextType } from './ACL.types';

export const ACLContext = createContext<ACLContextType>(initialState);
